import Posts from "../../pages/Posts";

const PostRoutes = [
  {
    path: "posts",
    element: <Posts />,
  },
];

export default PostRoutes;
